// extracted by mini-css-extract-plugin
module.exports = {"accordion":"styles_accordion__zQ18I","contentWrapper":"styles_contentWrapper__aCf_i","content":"styles_content__10Jtq"};